import { render } from "./Policy.vue?vue&type=template&id=1a2890ef&scoped=true"
import script from "./Policy.vue?vue&type=script&lang=js"
export * from "./Policy.vue?vue&type=script&lang=js"

import "./Policy.vue?vue&type=style&index=0&id=1a2890ef&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1a2890ef"

export default script